(function(window, angular) {
  "use strict";
  const m = angular.module("vvCommon");

  // 추천퀴즈가 유저에게 기존에 노출 되었는지를 판단.
  m.service('vvRecommendedQuizIds', function (vvSessionStorage) {
    const recommendedQuizIds = (function() {
      try {
        return JSON.parse(vvSessionStorage.get('vvRecommendedQuizIds')) || {};
      } catch (e) {
        return {};
      }
    })();

    this.isAlreadyRecommended = function(quizId) {
      const already = quizId in recommendedQuizIds;
      if (!already) {
        recommendedQuizIds[quizId] = 1;
      } else {
        recommendedQuizIds[quizId] += 1;
      }
      vvSessionStorage.set('vvRecommendedQuizIds', JSON.stringify(recommendedQuizIds));
      return already;
    };

    this.canRecommendQuiz = function (quizId) {
      return !(quizId in recommendedQuizIds) || recommendedQuizIds[quizId] <= 2;
    }
  });
})(window, window.angular);
